/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SidebarContent } from '@/components/blocks/SideBar/parts/Content';
import { sidebarAppBarContainerSX } from '@/components/blocks/SideBar/styles/appBar/container';
import { sidebarAppBarContentSX } from '@/components/blocks/SideBar/styles/appBar/content';
import { useDeviceType } from '@/data/deviceDetection';
import { combineSX } from '@/utils/combineSX';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AppBar, Drawer, Stack, Typography } from '@mui/material';
import { Breakpoint, SxProps } from '@mui/material/styles';
import { createContext, FC, PropsWithChildren, useCallback, useState } from 'react';

type Props = {
	title: string;
	href?: string;
	scrollable?: boolean;
	sidebarAppBarContainerSXP?:SxProps;
	sidebarAppBarContentSXP?:SxProps;
	sidebarAccordionSummarySXP?:SxProps;
	mobileBreakpoint?: Breakpoint;
	appBarId?:string;
	showAccordionTitle?:boolean;
	titleH2Component?:string;
};

export const AccordionContext = createContext<any>(null);

export const Sidebar: FC<PropsWithChildren<Props>> = ({
	title,
	showAccordionTitle = true,
	href,
	titleH2Component,
	scrollable = false,
	children,
	sidebarAppBarContainerSXP,
	sidebarAppBarContentSXP,
	sidebarAccordionSummarySXP,
	appBarId
}) => {
	const [open, setOpen] = useState<boolean>(false);
	const {isMobile} = useDeviceType();
	const toggleOpen = useCallback(() => {
		if (isMobile) setOpen(!open);
	}, [open, isMobile]);
	return isMobile ? (
		<AccordionContext.Provider value={{ toggleOpen }}>
			<AppBar id={appBarId??"sidebar_appbar"} position="fixed" sx={combineSX([sidebarAppBarContainerSX,sidebarAppBarContainerSXP??{}])} onClick={toggleOpen}>
				<Stack direction="row" alignItems="center" spacing={0.5}>
					<ExpandLessIcon sx={{color: '#000000'}}/>
					<Typography variant="body2" sx={combineSX([sidebarAppBarContentSX,sidebarAppBarContentSXP??{}])}>
						{title}
					</Typography>
				</Stack>
			</AppBar>
			<Drawer anchor="bottom" open={open}>
				<SidebarContent {...{ children, href, isMobile, scrollable, title, toggleOpen, sidebarAccordionSummarySXP,titleH2Component }} />
			</Drawer>
		</AccordionContext.Provider>
	) : (
		<AccordionContext.Provider value={{ toggleOpen }}>
			<SidebarContent {...{ children, href, isMobile, scrollable, title, toggleOpen, sidebarAccordionSummarySXP, showAccordionTitle, titleH2Component }} />
		</AccordionContext.Provider>
	);
};
